module.exports = __webpack_public_path__ + "static/media/cart.5a5e64e9.jpg";